import styled from 'styled-components'

export const PageWrapper = styled.div`
  max-width: 1230px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 60px;
  @media screen and (max-width: 1200px) {
    padding: 0 15px;
  }
  @media screen and (max-width: 720px) {
    margin-top: 0px;
    padding: 0;
  }
`

/**
 * Connect Wallet Page with Secret
 */
export const BigCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 1200px;
  padding: 123px 228px 122px;
  border-radius: 10px;
  box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.05);
  background-color: ${({ theme }) => theme.bg1};
  color: ${({ theme }) => theme.text1};
  text-align: center;
  @media screen and (max-width: 992px) {
    padding: 123px 150px 122px;
  }
  @media screen and (max-width: 720px) {
    padding: 20px;
  }
`

export const Title = styled.div`
  margin: 41px 0 16px;
  font-size: 40px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 1.07px;
  @media screen and (max-width: 992px) {
  }
  @media screen and (max-width: 768px) {
    font-size: 32px;
  }
`

export const Description = styled.div`
  margin: 16px 0;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: 0.37px;
  text-align: center;
  width: 100%;
  color: #7182aa;
  @media screen and (max-width: 720px) {
    width: 100%;
  }
`

export const ConnectMetamask = styled.div`
  width: 434px;
  height: 60px;
  margin: 39px 155px 0;
  border-radius: 8px;
  background-image: linear-gradient(98deg, #e45e37 0%, #d44f29 96%);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: 0.53px;
  text-align: center;
  color: #ffffff;
  @media screen and (max-width: 720px) {
    width: 100%;
    margin: 0;
  }
  img {
    width: 21.6px;
    height: 20px;
    margin: 0 10px 0 0;
    object-fit: contain;
  }
`

/**
 * Public community page
 */
export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 178px;
  padding: 33px 44.4px 34px 41px;
  border-radius: 10px;
  box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.05);
  background-color: #fff;
  background-color: ${({ theme }) => theme.bg1};
  color: ${({ theme }) => theme.text1};
  @media screen and (max-width: 992px) {
    gap: 100px;
  }
  @media screen and (max-width: 840px) {
    flex-direction: column;
    align-items: center;
    gap: 40px;
  }
`
export const HeaderLeft = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 17px;
  div:first-child {
    font-size: 30px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.8px;
  }
  div:nth-child(2) {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: 0.37px;
    color: #7182aa;
  }
  @media screen and (max-width: 840px) {
    align-items: center;
    text-align: center;
    div:nth-child(3) {
      margin-top: 7px;
    }
  }
`
export const AptButton = styled.a`
  width: 322px;
  height: 50px;
  padding: 15px 68px 16px;
  border-radius: 5px;
  background-image: linear-gradient(79deg, #1fc7ae 12%, #7c73b4 86%);
  font-size: 15px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.4px;
  text-align: center;
  text-decoration: none !important;
  color: ${({ theme }) => theme.text5};
  cursor:pointer;
  :hover {
    opacity: 0.9;
  }
  @media screen and (max-width: 720px) {
    width: 100%;
  }
`

export const SectionTitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  color: ${({ theme }) => theme.text1};
  div:nth-child(1) {
    font-size: 30px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.8px;
  }
  div:nth-child(2) {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: 0.37px;
    text-align: center;
    color: #7182aa;
  }
`

export const CardBig = styled.div`
  border-radius: 10px;
  box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.05);
  background-color: #fff;
  background-color: ${({ theme }) => theme.bg1};
  color: ${({ theme }) => theme.text1};
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  @media screen and (max-width: 840px) {
    flex-direction: column;
  }
`

export const CardBigContent = styled.div`
  padding: 33px 41px;
  width: 60%;
  display: flex;
  flex-direction: column;
  gap: 30px;
  @media screen and (max-width: 840px) {
    width: 100%;
  }
`

export const CardTitle = styled.div`
  padding: 0;
  font-size: 30px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.8px;
`

export const CardBigStrong = styled.div`
  font-size: 18px;
  font-weight: 500;
  line-height: 1.4;
  letter-spacing: 0.48px;
`

export const CardBigText = styled.div`
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.93;
  letter-spacing: 0.37px;
`

export const DiscordImage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  img {
    margin-right: -100px;
  }
  @media screen and (max-width: 840px) {
    padding: 0 41px;
    img {
      margin-right: 0;
      margin-bottom: -80px;
    }
  }
`

export const Cards = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex: 1 1 0px;
  gap: 30px;
`

export const CardSmall = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-width: 380px;
  max-width: 380px;
  padding: 33px 35px 45px 34px;
  border-radius: 10px;
  box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.05);
  background-color: ${({ theme }) => theme.bg1};
  color: ${({ theme }) => theme.text1};
  @media screen and (max-width: 720px) {
    min-width: 100%;
    max-width: 100%;
    witdh: 100%;
  }
  div:nth-child(2) {
    margin-top: 16px;
    margin-bottom: 12px;
    font-size: 15px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.4px;
  }
  div:nth-child(3) {
    margin-bottom: 20px;
    font-size: 25px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.67px;
    span {
      font-size: 14px;
    }
  }
  div:nth-child(4) {
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.37px;
    text-align: center;
    color: #7182aa;
  }
`

export const CardSteps = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 21px;
  width: 100%;
  min-width: 380px;
  max-width: 380px;
  text-align: center;
  padding: 33px 35px 45px 34px;
  border-radius: 10px;
  box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.05);
  background-color: ${({ theme }) => theme.bg1};
  color: ${({ theme }) => theme.text1};
  @media screen and (max-width: 720px) {
    min-width: 100%;
    max-width: 100%;
    witdh: 100%;
  }
  div:nth-child(2) {
    font-size: 20px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.53px;
  }
  div:nth-child(3) {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.37px;
    text-align: center;
    color: #7182aa;
  }
`

export const Faq = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const FaqRow = styled.div`
  padding: 29px 26.5px 30px 28px;
  border-radius: 20px;
  border: solid 1px #224765;
  background-image: linear-gradient(to bottom, #11314a, #0c2539);
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.01), 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 16px 24px rgba(0, 0, 0, 0.04),
    0px 24px 32px rgba(0, 0, 0, 0.01);
`

export const FaqHead = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 24px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.4px;
`

export const FaqBody = styled.div`
  margin-top: 20px;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.64;
  letter-spacing: 0.37px;
`
